import { createRelayResource } from '@townsquare/relay-utils';
import type { ResourceContext } from '@townsquare/router/types';

import TeamUpdatesViewQuery, {
	type TeamUpdatesViewQuery as TeamUpdatesViewQueryType,
} from '../TeamUpdatesView/__generated__/TeamUpdatesViewQuery.graphql';

export const teamUpdatesResource = createRelayResource<TeamUpdatesViewQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;
		const teamId = routerContext?.match?.params.id ?? '';
		return {
			query: TeamUpdatesViewQuery,
			variables: {
				teamId: teamId,
				workspaceUUID: context.workspace?.UUID || '',
				cloudId: context.workspace?.cloudId,
			},
			options: {
				fetchPolicy: 'store-and-network',
			},
		};
	},
});
